import React, { useRef, useEffect } from 'react';

const getCenterPos = (markers: Marker[]) =>
  new google.maps.LatLng(markers[0].latitude, markers[0].longitude);

interface Marker {
  latitude: number;
  longitude: number;
  empty: boolean;
}

interface MapProps {
  markers: Marker[];
  className?: string;
  children?: React.ReactNode | React.ReactNode[];
}

const MapComponent = ({ markers, className, children }: MapProps) => {
  const markerRefs = useRef<google.maps.Marker[]>([]);
  const mapRef = useRef<google.maps.Map | undefined>(undefined);
  const mapContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (mapContainerRef.current) {
      mapRef.current = new google.maps.Map(mapContainerRef.current, {
        center: getCenterPos(markers),
        zoom: 12,
        disableDefaultUI: true,
        scrollwheel: false,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
      });

      markerRefs.current.forEach((marker) => marker.setMap(null));
      markerRefs.current = [];

      markers.forEach((marker) =>
        markerRefs.current.push(
          new google.maps.Marker({
            position: new google.maps.LatLng(marker.latitude, marker.longitude),
            map: mapRef.current,
            icon: {
              path: 'M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z',
              fillColor: '#f53850',
              fillOpacity: 1,
              strokeColor: '#f53850',
              strokeWeight: 0,
              scale: 1,
              labelOrigin: new google.maps.Point(15, 15),
            },
          }),
        ),
      );
    }
  }, []);

  return (
    <div data-am-map="" className={className}>
      <div ref={mapContainerRef} className="map" />
      {children}
    </div>
  );
};

export default MapComponent;
